import D3EAppTemplate from "../models/D3EAppTemplate";
import D3EAppTemplateCategory from "../models/D3EAppTemplateCategory";

export default class TemplateUtils {
  public constructor() {}
  public static getAppTemplateList(
    categories: Array<D3EAppTemplateCategory>
  ): Array<D3EAppTemplate> {
    let templates: Array<D3EAppTemplate> = [];

    for (let ctg of categories) {
      for (let appTemplate of ctg.apps) {
        templates.add(appTemplate);
      }
    }

    return templates;
  }
}
